<img class="imgToZoom" (click)="setZoom($event, true)" [src]="src" />

<div class="lightbox" *ngIf="showZoom" [ngClass]="{ 'active': showZoom }">
  <button mat-flat-button (click)="setZoom($event, false)" class="mb-2">
    <mat-icon>close</mat-icon>
    Cerrar
  </button>
  <img [src]="src" class="imgZoom">
</div>
